import blockedOrders from './blocked-orders.json'
import credit from './credit.json'
import creditIndexScores from './credit-index-scores.json'
import creditLimitReviews from './credit-limit-reviews.json'
import customers from './customers.json'
import delegationOfAuthority from './delegation-of-authority.json'
import exports from './exports.json'
import googleFinancialStatements from './google-financial-statements.json'
import initiatives from './initiatives.json'
import massCreditLimitReviews from './mass-credit-limit-reviews.json'
import multipliers from './multipliers.json'
import provinceAovPerCarton from './province-aov-per-carton.json'
import provinceOrderCutoffs from './province-order-cutoffs.json'
import reviewEvents from './review-events.json'
import sapImports from './sap-imports.json'
import veryLowRiskCustomers from './very-low-risk-customers.json'

export default {
  ...blockedOrders,
  ...credit,
  ...creditIndexScores,
  ...creditLimitReviews,
  ...customers,
  ...delegationOfAuthority,
  ...exports,
  ...googleFinancialStatements,
  ...initiatives,
  ...massCreditLimitReviews,
  ...multipliers,
  ...provinceAovPerCarton,
  ...provinceOrderCutoffs,
  ...reviewEvents,
  ...sapImports,
  ...veryLowRiskCustomers,
}
